import { useTranslation } from 'react-i18next';
import { useEffect, useState, useContext, useRef } from 'react';
import { Stepper, Button, TEOLoader } from '@teo/components';
import { useMobile } from '@/util';
import AddUserTeamStep from './Steps/AddUserTeamStep';
import HomePageStep from './Steps/HomePageStep';
import SharingSettingsStep from './Steps/SharingSettingsStep';
import CommunicationStep from './Steps/CommunicationStep';
import { axios } from '@/axios';
import { config } from '@/config';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { Userwithorganisationwithidps } from '@/models';
import { initFroala } from '@/components/Froala/froala.js';
import AddFollowersStep from './Steps/AddFollowersStep';
import { useGet } from '@/query';
import {
  useConditionCompetencies,
  conditionCompetenceIds,
} from '@/components/LearningPath/CompetenceConditions';

const steps = ['users', 'homepage', 'share', 'communication'];

const StepsComponent = ({
  //authUser,
  course,
  courseInfo,
  teamInfo,
  student,
  activeCourse,
  setIsOpenAddContent,
  setActiveCourse,
  create,
  activeSteps = [1, 2, 3],
  activeStep = 1,
  submitButtonLabel = 'pages.course_content_flow.add_team',
  onSubmit = null,
  onClose,
  setLoader,
  publicationType,
}: any) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(activeStep);
  const [loadStep, setLoadStep] = useState(false);
  const [loadedStep, setLoadedStep] = useState([false, false, false, false]);
  const isMobile = useMobile();

  const { auth } = useContext(AuthContext);
  const authUser = auth?.user as Userwithorganisationwithidps;

  //share step state
  const [correctionType, setCorrectionType] = useState<string>(
    course?.correctionType || 'immediate'
  );
  const [emailCertificate, setEmailCertificate] = useState<boolean>(
    course?.emailCertificate || false
  );
  const [courseType, setCourseType] = useState<string>(
    course?.courseType || course?.publicationCourseType || 'course'
  );
  const [courseAccess, setCourseAccess] = useState<string>(
    course?.courseAccess ||
      (courseType == 'leervacature' ? 'public' : 'private')
  );

  const [courseEndDate, setCourseEndDate] = useState<Date | null | undefined>(
    course?.courseEndDate || null
  );
  const [inOrder, setInOrder] = useState<boolean>(course?.inOrder || false);
  const [isMandatory, setIsMandatory] = useState<boolean>(course?.isMandatory);
  const [forceUpdates, setForceUpdates] = useState<boolean>(
    course?.forceUpdates
  );
  const [minScore, setMinScore] = useState<number>(course?.minScore);
  const [courseTimer, setCourseTimer] = useState<number>(
    course?.courseTimer || 0
  );
  const [courseStartDate, setCourseStartDate] = useState<
    Date | null | undefined
  >(course?.courseStartDate || new Date());
  const [courseName, setCoursename] = useState<number>(
    course?.courseName || course?.name
  );
  const [courseDescription, setCourseDescription] = useState(
    course?.courseDescription || course?.description
  );
  const [courseImage, setCourseImage] = useState<string>(
    course?.courseImage || course?.image
  );

  const [prevContentOrganisation, setPrevContentOrganisation] = useState<any>(
    []
  );
  const [orgState, setOrgState] = useState<any>({
    library: { organizations: [] },
  });

  const [loadeFroala, setLoadeFroala] = useState(false);

  const [lpNode, setLpNode] = useState<any>(null);
  const [competenciesConditions, setCompetenciesConditions] =
    useState<boolean>(false);
  const [competenciesConditionsList, setCompetenciesConditionsList] = useState<
    any[]
  >([]);
  const [conditionIds, setConditionIds] = useState<number[]>([]);

  useGet('/learningpathnodes', {
    enabled: !create && !!course?.id && !!course?.learningpathId,
    learningpathId: course?.learningpathId,
    objectId: course?.id,
    type: 'course',
    onSuccess: (result: any) => {
      const node = result?.data?.[0] || null;
      setLpNode(node);
      setCompetenciesConditions(!!node?.competenciesConditions);
      setConditionIds(node?.competenciesConditionsArr || []);
    },
  });

  useConditionCompetencies(conditionIds, setCompetenciesConditionsList);

  const [currentUsers, setCurrentUsers] = useState([]);
  const [currentTeams, setCurrentTeams] = useState([]);
  const [currentTeachers, setCurrentTeachers] = useState([]);

  const [delUsers, setDelUsers] = useState<any>([]);
  const [delTeams, setDelTeams] = useState<any>([]);
  const [delTeachers, setDelTeachers] = useState<any>([]);

  useGet((authUser?.role || 0) >= 90 ? '/studentswithteam' : '/mystudents', {
    enabled: !!course?.id,
    userId: (authUser?.role || 0) >= 90 ? undefined : authUser?.id,
    organisationId:
      (authUser?.role || 0) >= 90 ? undefined : authUser?.activeOrganisationId,
    courseId: course?.id,
    onSuccess: (result: any) => {
      setCurrentUsers(result?.data || []);
    },
  });

  useGet('/courseteamdetails', {
    enabled: !!course?.id,
    courseId: course?.id,
    onSuccess: (result: any) => {
      setCurrentTeams(result?.data || []);
    },
  });

  useGet('/teachers', {
    enabled: !!course?.id && courseType !== 'instruction',
    courseId: course?.id,
    onSuccess: (result: any) => {
      setCurrentTeachers(result?.data || []);
    },
  });

  const handleOpen = async () => {
    await initFroala();
    setTimeout(() => {
      setLoadeFroala(true);
    }, 100);
  };
  useEffect(() => {
    handleOpen();
  }, []);

  const shareState = {
    correctionType,
    setCorrectionType,
    emailCertificate,
    setEmailCertificate,
    courseAccess,
    setCourseAccess,
    courseEndDate,
    setCourseEndDate,
    inOrder,
    setInOrder,
    isMandatory,
    setIsMandatory,
    forceUpdates,
    setForceUpdates,
    minScore,
    setMinScore,
    courseStartDate,
    setCourseStartDate,
    courseName,
    setCoursename,
    setCourseDescription,
    courseDescription,
    setPrevContentOrganisation,
    prevContentOrganisation,
    orgState,
    setOrgState,
    courseImage,
    setCourseImage,
    courseType,
    setCourseType,
    courseTimer,
    setCourseTimer,
    lpNode,
    competenciesConditions,
    setCompetenciesConditions,
    competenciesConditionsList,
    setCompetenciesConditionsList,
  };

  const saveConditions = async () => {
    if (!lpNode) return;
    const changes: any = {};
    if (competenciesConditions !== !!lpNode.competenciesConditions) {
      changes.competenciesConditions = competenciesConditions;
    }
    const ids = conditionCompetenceIds(competenciesConditionsList);
    if (ids.join(',') !== (lpNode.competenciesConditionsArr || []).join(',')) {
      changes.competenciesConditionsArr = ids;
    }
    if (Object.keys(changes).length === 0) return;
    await axios.put(
      `${config.backend}/learningpathnode/${lpNode.learningpathId}/${lpNode.id}`,
      changes
    );
  };

  //save share settings, will create a new course when none exist
  const saveShare = async (myCourse = course) => {
    const changes: any = {};
    if (courseType !== course?.courseType) {
      changes.courseType = courseType;
    }
    if (correctionType !== course?.correctionType) {
      changes.correctionType = correctionType;
    }
    if (emailCertificate !== course?.emailCertificate) {
      changes.emailCertificate = emailCertificate;
    }
    if (courseAccess !== course?.courseAccess) {
      changes.courseAccess = courseAccess;
    }
    if (courseEndDate !== course?.courseEndDate) {
      changes.courseEndDate = courseEndDate ? courseEndDate : null;
    }
    if (inOrder !== course?.inOrder) {
      changes.inOrder = inOrder;
    }
    if (isMandatory !== course?.isMandatory) {
      changes.isMandatory = isMandatory;
    }
    if (forceUpdates !== course?.forceUpdates) {
      changes.forceUpdates = forceUpdates;
    }
    if (courseTimer !== course?.courseTimer) {
      changes.courseTimer = courseTimer;
    }
    if (minScore !== course?.minScore) {
      changes.minScore = minScore;
    }
    if (courseStartDate !== course?.courseStartDate) {
      changes.courseStartDate = courseStartDate;
    }
    if (courseName !== course?.courseName) {
      changes.courseName = courseName;
    }
    if (courseDescription !== course?.courseDescription) {
      changes.courseDescription = courseDescription;
    }
    if (picture !== courseInfo?.picture) {
      changes.courseImage = picture;
    }

    const axiosFn = myCourse.id
      ? axios.put.bind(null, `${config.backend}/course/${myCourse.id}`)
      : axios.post.bind(null, `${config.backend}/courses`);

    const result: any = await axiosFn({
      coursecontentId: myCourse.coursecontentId,
      ...changes,
    });

    await saveConditions();

    myCourse = result?.data;

    if (orgState?.library?.organizations?.length > 0) {
      const selectOrg = orgState?.library?.organizations;
      for (const addObj2 of selectOrg) {
        const existingObj = prevContentOrganisation?.find(
          (obj1: any) => obj1?.key === addObj2?.key
        );
        if (!existingObj) {
          await axios
            .post(`${config.backend}/membercourses`, {
              courseId: myCourse.id,
              organisationId: addObj2?.key,
            })
            .catch(() => {
              //likely already exists
            });
        }
      }
      for (const removedObj of prevContentOrganisation) {
        const existingObj = orgState?.library?.organizations?.find(
          (obj1: any) => obj1?.key === removedObj?.key
        );
        if (!existingObj) {
          await axios.delete(
            `${config.backend}/membercourse/${removedObj?.key}/${myCourse.id}`
          );
        }
      }
    }
    if (
      orgState?.library?.organizations?.length < 1 &&
      prevContentOrganisation?.length > 0
    ) {
      for (const removedObj of prevContentOrganisation) {
        await axios.delete(
          `${config.backend}/membercourse/${removedObj?.key}/${myCourse.id}`
        );
      }
    }

    return result?.data;
  };
  //

  //user/teams state
  const [newUsers, setNewUsers] = useState<any[]>([]);
  const [newTeams, setNewTeams] = useState<any[]>([]);
  const [newTeachers, setNewTeachers] = useState<any[]>([]);
  const [hasCustomLanding, setHasCustomLanding] = useState<boolean>(
    course?.hasCustomLanding ? course?.hasCustomLanding : true
  );

  const userState = {
    newUsers,
    setNewUsers,
    newTeachers,
    setNewTeachers,
    newTeams,
    setNewTeams,
  };

  const saveUser = async (myCourse = course) => {
    //this function was rewritten to be all sequential due to a deadlock on
    //courseteams. If you optimize this, make sure the deadlock issue is fixed.
    //TEO-1145
    const results: Array<
      { status: 'fulfilled'; value: any } | { status: 'rejected'; reason: any }
    > = [];

    const settle = async <T,>(fn: () => Promise<T>) => {
      try {
        const value = await fn();
        results.push({ status: 'fulfilled', value });
        return value;
      } catch (reason) {
        results.push({ status: 'rejected', reason });
        return undefined;
      }
    };
    // delete the users
    for (const usr of delUsers) {
      await settle(() =>
        axios.delete(
          `${config.backend}/follow/${course?.id}/${
            usr?.studentId || usr?.userId
          }/`
        )
      );
    }

    // delete the teachers
    for (const tech of delTeachers) {
      await settle(() =>
        axios.delete(
          `${config.backend}/teach/${course?.id}/${
            tech?.studentId || tech?.userId
          }/`
        )
      );
    }

    // delete the teams
    for (const team of delTeams) {
      await settle(() =>
        axios.delete(`${config.backend}/courseteam/${course?.id}/${team?.id}/`)
      );
    }

    // 1) save the teams
    for (const team of newTeams) {
      await settle(() =>
        axios.post(`${config.backend}/courseteams`, {
          courseId: myCourse.id,
          teamId: team?.teamId || team?.id,
        })
      );
    }

    // 2) save settings
    if (hasCustomLanding) {
      await settle(() =>
        axios.put(`${config.backend}/course/${myCourse.id}`, {
          hasCustomLanding,
        })
      );
    } else {
      await settle(() =>
        axios.put(`${config.backend}/course/${myCourse.id}`, {
          hasCustomLanding,
          courseDescription: course?.description,
          courseName: course?.name,
          courseImage: course?.image,
        })
      );
    }

    const provisionOne = async (item: any) => {
      if (!item?.newUser) return item;

      const res = await axios.post(
        `${config.backend}/invite/provision?lang=${auth?.user?.lang}`,
        {
          organisationId: auth?.user?.activeOrganisationId,
          email: item.label,
          firstName: item.firstName,
          lastName: item.lastName,
          phone: item.phone,
          role: Math.min(item.role, 50),
        }
      );

      return Object.assign({}, res?.data, {
        key: res?.data?.id,
        role: item.role,
      });
    };

    // 3) provision users
    const students: any[] = [];
    for (const item of newUsers) {
      const student = await settle(() => provisionOne(item));
      if (student !== undefined) students.push(student);
    }

    // 4) provision teachers
    const teachers: any[] = [];
    for (const item of newTeachers) {
      const teacher = await settle(() => provisionOne(item));
      if (teacher !== undefined) teachers.push(teacher);
    }

    // 5) ensure org membership
    for (const student of students) {
      await settle(() =>
        axios.post(`${config.backend}/members`, {
          organisationId: authUser?.activeOrganisationId,
          userId: student?.userId || student?.id,
        })
      );
    }

    for (const teacher of teachers) {
      await settle(() =>
        axios.post(`${config.backend}/members`, {
          organisationId: authUser?.activeOrganisationId,
          userId: teacher?.userId || teacher?.id,
        })
      );
    }

    // 6) follows
    for (const student of students) {
      await settle(() =>
        axios.post(`${config.backend}/follows`, {
          courseId: myCourse.id,
          userId: student?.userId || student?.id,
        })
      );
    }

    // 7) teaches
    for (const teacher of teachers) {
      await settle(() =>
        axios.post(`${config.backend}/teaches`, {
          courseId: myCourse.id,
          userId: teacher?.userId || teacher?.id,
        })
      );
    }

    return results;
  };

  //commm step state
  const [lvCompletePassed, setLvCompletePassed] = useState<string>(
    courseInfo?.lvCompletePassed || ''
    // t('pages.course_content_flow.step_4.message_passed_default')
  );
  const [lvCompleteFailed, setLvCompleteFailed] = useState<string>(
    courseInfo?.lvCompleteFailed || ''
    // t('pages.course_content_flow.step_4.message_failed_default')
  );
  const [lvCustomMail, setLvCustomMail] = useState<string>(
    courseInfo?.lvCustomMail
  );
  const [onboardingRequired, setOnboardingRequired] = useState<string>(
    course?.onboardingRequired
  );
  const [onboardingSteps, setOnboardingSteps] = useState<string[]>(
    courseInfo?.onboardingSteps || [
      'onboarding_names_step',
      'onboarding_email_step',
      'onboarding_location_step',
      'onboarding_regime_step',
      'onboarding_referral_step',
      'onboarding_current_work_step',
      'onboarding_contact_step',
      'onboarding_diploma_step',
    ]
  );
  const [nrOfReminders, setNrOfReminders] = useState<number>(
    courseInfo?.nrOfReminders || 0
  );
  const [reminderInterval, setReminderInterval] = useState<number>(
    courseInfo?.reminderInterval || 0
  );
  const [doNotRemindProgress, setDoNotRemindProgress] = useState<number>(
    courseInfo?.doNotRemindProgress * 100 || 0
  );
  const [reminderEmail, setReminderEmail] = useState<string>(
    courseInfo?.reminderEmail
  );
  const [welcomeMessage, setWelcomeMessage] = useState<string>(
    courseInfo?.welcomeMessage ||
      t(
        'pages.course_content_flow.step_4.onboarding.message_introduction_onboardin'
      )
  );

  const commState = {
    lvCompletePassed,
    setLvCompletePassed,
    lvCompleteFailed,
    setLvCompleteFailed,
    lvCustomMail,
    setLvCustomMail,
    onboardingRequired,
    setOnboardingRequired,
    onboardingSteps,
    setOnboardingSteps,
    nrOfReminders,
    setNrOfReminders,
    reminderInterval,
    setReminderInterval,
    doNotRemindProgress,
    setDoNotRemindProgress,
    reminderEmail,
    setReminderEmail,
    welcomeMessage,
    setWelcomeMessage,
    course,
  };

  const saveComm = async (myCourse = course, myCourseInfo = courseInfo) => {
    const changes: any = {};
    if (lvCompletePassed !== courseInfo?.lvCompletePassed) {
      changes.lvCompletePassed = lvCompletePassed;
    }
    if (lvCompleteFailed !== courseInfo?.lvCompleteFailed) {
      changes.lvCompleteFailed = lvCompleteFailed;
    }
    if (lvCustomMail !== courseInfo?.lvCustomMail) {
      changes.lvCustomMail = lvCustomMail;
    }
    if (onboardingSteps !== courseInfo?.onboardingSteps) {
      changes.onboardingSteps = onboardingSteps;
    }
    if (nrOfReminders !== courseInfo?.nrOfReminders) {
      changes.nrOfReminders = nrOfReminders;
    }
    if (reminderInterval !== courseInfo?.reminderInterval) {
      changes.reminderInterval = reminderInterval;
    }
    if (doNotRemindProgress / 100 !== courseInfo?.doNotRemindProgress) {
      changes.doNotRemindProgress = doNotRemindProgress / 100;
    }
    if (reminderEmail !== courseInfo?.reminderEmail) {
      changes.reminderEmail = reminderEmail;
    }
    if (welcomeMessage !== courseInfo?.welcomeMessage) {
      changes.welcomeMessage = welcomeMessage;
    }

    const axiosFn = myCourseInfo?.id
      ? axios.put.bind(
          null,
          `${config.backend}/courseinfo/${myCourseInfo.courseId}`
        )
      : axios.post.bind(null, `${config.backend}/courseinfos`);

    const result: any = await axiosFn({
      courseId: myCourse?.id,
      ...changes,
    });

    await axios.put(`${config.backend}/course/${myCourse?.id}`, {
      onboardingRequired: onboardingRequired ? onboardingRequired : false,
    });

    return result?.data;
  };

  //homepage state
  const [picture, setPicture] = useState<string>(courseInfo?.picture);
  const [abstract, setAbstract] = useState<string>(courseInfo?.abstract);
  const [bannerPicture, setBannerPicture] = useState<string>(
    courseInfo?.bannerPicture
  );
  const [subTitles, setSubTitles] = useState<string[]>(
    courseInfo?.subTitles || []
  );
  const [subImages, setSubImages] = useState<string[]>(
    courseInfo?.subImages || []
  );
  const [subTexts, setSubTexts] = useState<string[]>(
    courseInfo?.subTexts || []
  );
  const [name, setName] = useState<number>(course?.name);

  const homepageState = {
    hasCustomLanding,
    setHasCustomLanding,
    picture,
    setPicture,
    abstract,
    setAbstract,
    subTitles,
    setSubTitles,
    subImages,
    setSubImages,
    subTexts,
    setSubTexts,
    name,
    setName,
    courseName,
    setCoursename,
    setCourseDescription,
    courseDescription,
    setBannerPicture,
    bannerPicture,
  };

  const saveHome = async (myCourse = course, myCourseInfo = courseInfo) => {
    const changes: any = {};

    if (picture !== courseInfo?.picture) {
      changes.picture = picture;
    }
    if (bannerPicture !== courseInfo?.bannerPicture) {
      changes.bannerPicture = bannerPicture;
    }
    if (abstract !== courseInfo?.abstract) {
      changes.abstract = abstract;
    }
    if (subTitles !== courseInfo?.subTitles) {
      changes.subTitles = subTitles;
    }
    if (subImages !== courseInfo?.subImages) {
      changes.subImages = subImages;
    }
    if (subTexts !== courseInfo?.subTexts) {
      changes.subTexts = subTexts;
    }

    const axiosFn = myCourseInfo.id
      ? axios.put.bind(
          null,
          `${config.backend}/courseinfo/${myCourseInfo.courseId}`
        )
      : axios.post.bind(null, `${config.backend}/courseinfos`);

    const result: any = await axiosFn({
      courseId: myCourse?.id,
      ...changes,
    });

    return result?.data;
  };

  const [saveShareFn, setSaveShareFn] = useState<any>(undefined);

  const [globalState, setGlobalState] = useState<any>({
    teams: [],
    sharingSettings: {
      autoCorrect: course?.correctionType === 'immediate' ? true : false,
      certificate: course?.emailCertificate || false,
      courseAccess: course?.courseAccess || 'protected',
      endDay: course?.courseEndDate || null,
      inOrder: course?.inOrder || 'false',
      mandatory: course?.isMandatory,
      forceUpdates: course?.forceUpdates,
      score: course?.minScore * 100,
      startDay: course?.courseStartDate || new Date(),
    },
  });

  const shareRef = useRef(null);
  const userRef = useRef(null);

  const [customHomepage, setCustomHomepage] = useState<boolean>(false);
  // const [addStep, setAddStep] = useState(0);
  const [courseId, setCourseId] = useState(null);
  const [action, setAction] = useState<boolean>(false);

  const [myActiveStaps, setMyActiveSteps] = useState(activeSteps);

  // const parseStep = () => {
  //   const realStepIndex = step === 1 || addStep ? step : step + 1;
  //   return steps[realStepIndex - 1];
  // };

  const [newStepType, setNewStepType] = useState(4);

  useEffect(() => {
    if (courseType === 'instruction') {
      setNewStepType(2);
    } else {
      setNewStepType(3);
    }
  }, [courseType]);
  useEffect(() => {
    setTimeout(() => {
      document.body.style.overflow = 'hidden';
    }, 0);
  }, []);

  const handleSave = async () => {
    setLoader(true);

    try {
      let result;
      let newCourse;

      if (create) {
        try {
          result = await axios.get(
            `${config.backend}/publish/lastversion/${course.id}`
          );
        } catch (e) {
          result = await axios.post(
            `${config.backend}/publish/${course.id}`,
            {}
          );
        }

        newCourse = await saveShare({
          coursecontentId: result?.data?.id,
        });
      } else {
        newCourse = await saveShare();
      }

      // Fully sequential from here
      await saveUser(newCourse);

      const newCourseInfo = await saveComm(newCourse, courseInfo);

      await saveHome(newCourse, newCourseInfo);

      if (create) {
        await axios
          .post(`${config.backend}/membercourses`, {
            courseId: newCourse.id,
            organisationId: auth?.user?.activeOrganisationId,
          })
          .catch(() => {
            //likely already exists
          });
      }

      onSubmit && onSubmit(newCourse);
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="relative h-full max-h-[calc(100vh_-_96px)] border-t border-grey-02">
      <Stepper>
        {myActiveStaps.includes(1) && (
          <Stepper.Item
            isActive={step === 1}
            isDone={step > 1}
            onClick={() => {
              setStep(1);
              step !== 1 && !loadedStep[0] && setLoadStep(true);
            }}
            step="1"
          >
            {!isMobile && <>{t('pages.course_content_flow.users_teams')}</>}
          </Stepper.Item>
        )}
        {courseType !== 'instruction' && (
          <Stepper.Item
            isActive={step === 2}
            isDone={step > 2}
            onClick={() => {
              setStep(2);
              step !== 2 && !loadedStep[1] && setLoadStep(true);
            }}
            step="2"
          >
            {!isMobile && <>{t('pages.course_content_flow.homepage')}</>}
          </Stepper.Item>
        )}
        <Stepper.Item
          isActive={step === newStepType}
          isDone={step > newStepType}
          onClick={() => {
            setStep(newStepType);
            step !== newStepType &&
              !loadedStep[newStepType - 1] &&
              setLoadStep(true);
          }}
          step={`${newStepType}`}
        >
          {!isMobile && <>{t('pages.course_content_flow.sharing_settings')}</>}
        </Stepper.Item>
        <Stepper.Item
          isActive={step === newStepType + 1}
          isDone={step > newStepType + 1}
          onClick={() => {
            setStep(newStepType + 1);
            step !== newStepType + 1 &&
              !loadedStep[newStepType] &&
              setLoadStep(true);
          }}
          step={`${newStepType + 1}`}
        >
          {!isMobile && <>{t('pages.course_content_flow.communication')}</>}
        </Stepper.Item>
      </Stepper>
      <div className="relative h-full max-h-[calc(100vh_-_256px)] overflow-y-auto py-8">
        {loadStep && (
          <div className="fixed absolute inset-0 z-[13] z-10 flex bg-white/75">
            <div className="m-auto">
              <TEOLoader
                loaderSrc="/images/TEOloader.gif"
                className="w-[110px]"
              />
            </div>
          </div>
        )}
        <div className="mx-auto flex max-w-screen-md flex-col justify-center px-3">
          <div className="relative flex flex-col justify-center">
            {step === 1 && (
              <AddFollowersStep
                state={userState}
                teamInfo={teamInfo}
                student={student}
                setLoadStep={setLoadStep}
                courseType={courseType}
                currentUsers={currentUsers}
                setCurrentUsers={setCurrentUsers}
                currentTeams={currentTeams}
                setCurrentTeams={setCurrentTeams}
                currentTeachers={currentTeachers}
                setCurrentTeachers={setCurrentTeachers}
                setDelUsers={setDelUsers}
                setDelTeams={setDelTeams}
                setDelTeachers={setDelTeachers}
                loadedStep={() => {
                  const newLoader = loadedStep?.map((el, i) =>
                    i === 0 ? true : el
                  );
                  setLoadedStep(newLoader);
                }}
              />
            )}
            {step === 2 && courseType !== 'instruction' && (
              <HomePageStep
                course={course}
                state={homepageState}
                setLoadStep={setLoadStep}
                loadedStep={() => {
                  const newLoader = loadedStep?.map((el, i) =>
                    i === 1 ? true : el
                  );
                  setLoadedStep(newLoader);
                }}
              />
            )}
            {step === newStepType && (
              <SharingSettingsStep
                course={course}
                state={shareState}
                setLoadStep={setLoadStep}
                publicationType={publicationType}
                courseTypeNoInstruction={courseType !== 'instruction'}
                loadedStep={() => {
                  const newLoader = loadedStep?.map((el, i) =>
                    i === newStepType - 1 ? true : el
                  );
                  setLoadedStep(newLoader);
                }}
              />
            )}
            {step === newStepType + 1 && (
              <CommunicationStep
                state={commState}
                loadeFroala={loadeFroala}
                setLoadStep={setLoadStep}
                courseType={courseType}
                create={create}
                loadedStep={() => {
                  const newLoader = loadedStep?.map((el, i) =>
                    i === newStepType ? true : el
                  );
                  setLoadedStep(newLoader);
                }}
              />
            )}
          </div>
        </div>
      </div>
      <div className="mt-auto flex border-t border-grey-02 py-5">
        <div className="mx-auto flex w-full max-w-screen-md justify-end px-3">
          <Button
            variant="outline"
            disabled={step === myActiveStaps[0]}
            onClick={() => {
              setStep(step - 1);
              setLoadStep(true);
            }}
            className="mr-auto"
            data-testid="prevBtn"
          >
            {t('button.previous')}
          </Button>
          <Button
            className="mr-2"
            variant={!create ? 'outline' : undefined}
            disabled={step === newStepType + 1}
            onClick={() => {
              setStep(step + 1);
              setLoadStep(true);
            }}
            data-testid="nextBtn"
          >
            {t('button.next')}
          </Button>
          {(!create || step === newStepType + 1) && (
            <Button
              onClick={() => {
                document.body.style.overflow = 'unset';
                handleSave();
              }}
              data-testid="nextBtn"
            >
              {t('button.save')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default StepsComponent;
